export default __webpack_public_path__ + "static/media/Group 159.c5a458d7.png";